'use client';

import { useRouter } from 'next/navigation';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { login } from '@/app_lib/services/tinypass/service';

const trackingData = {
  data: {
    // biome-ignore lint/style/useNamingConvention: external data
    contentPlacementCD: 'header',
    eventAction: 'top header links',
    eventCategory: 'navigation',
    eventLabel: 'sign in',
  },
};

export const SignInButton = ({ className, disabled = false }: { className?: string; disabled?: boolean }) => {
  const router = useRouter();

  return (
    <ButtonV2
      as='button'
      className={className}
      disabled={disabled}
      isTertiary
      onClick={() => login({ onLogin: () => router.refresh() })}
      trackingData={trackingData}
    >
      Sign in
    </ButtonV2>
  );
};
